import React, { useEffect, useState } from "react";
import "./style.scss";
import Tabination from "../../reusableComponents/Tabination";
import AccountOverview from "../../layouts/TradeList/AccountOverview";
import TransactionHistory from "../../layouts/TradeList/TransactionHistory";
import ProfileDetails from "../../layouts/TradeList/ProfileDetails";
import { Navigate, Route, Routes } from "react-router-dom";
import TradeHistory from "../../layouts/TradeList/TradeHistory";
import AffiliateTable from "../../layouts/TradeList/AffiliateList";
import { useDispatch, useSelector } from "react-redux";
import {
  getAccountListSuccess,
  getAccountMetrics,
  getAccountMetricsFailure,
  getAccountMetricsSuccess,
  getTraderJournal,
  setActiveAccount,
} from "../../store/reducers/accountSlice";
import axios from "axios";
import {
  baseUrl,
  getAccountMetricsRequest,
  getBalanceChartRequest,
} from "../../utils/api/apis";
import { setIsLoading } from "../../store/reducers/authSlice";
function TradersList2() {
  const dispatch = useDispatch();
  const idToken = useSelector((state) => state.auth.idToken);
  const items = [
    {
      name: "Account Overview",
      path: "account-overview",
    },
    {
      name: "Trade History",
      path: "trade-history",
    },
    // {
    //   name: "Transaction History",
    //   path: "transaction-history",
    // },
    {
      name: "Affiliate List",
      path: "affiliate-list",
    },
    {
      name: "Account Details",
      path: "account-details",
    },
  ];

  const activeUser = useSelector(
    (state) => state.account.accountList.activeUser
  );
  // Hitting search user api and getting user Id and then passing the user ID to fetch user accounts
  useEffect(() => {
    console.log(activeUser);
  }, [activeUser]);
  // handle account metrics
  const [accountsData, setAccountsData] = useState({});
  const accountsDataRedux = useSelector(
    (state) => state.account.accountMetrics.data
  );
  useEffect(() => {
    setAccountsData(accountsDataRedux);
  }, [accountsDataRedux]);
  // handle active account id
  const activeAccountRedux = useSelector(
    (state) => state.account.accountList.activeAccount.id
  );
  const [activeAccountUser, setActiveAccountUser] = useState(null);
  const FetchUserAccounts = async () => {
    try {
      // Configure the headers
      const config = {
        headers: { Authorization: `Bearer ${idToken}` },
      };

      // Extract user ID from activeUser
      const userId =
        activeUser?.user_id || activeUser?.login_id || activeUser?.id;

      // Ensure userId is a valid number
      if (!userId || isNaN(userId)) {
        console.error("Invalid userId:", userId);
        return;
      }

      // Fetch user accounts list
      const response = await axios.get(
        `${baseUrl}account/admin/account-filter/?user_id=${userId}`,
        config
      );

      const userAccountsList = response.data;

      // Dispatch the accounts list to Redux
      dispatch(getAccountListSuccess(userAccountsList));

      // Find the selected account ID from the list
      const findSelectedIdFromTable = userAccountsList.find(
        (obj) => obj.login_id === activeUser.login_id
      );

      // Dispatch the active account to Redux
      dispatch(
        setActiveAccount(
          findSelectedIdFromTable ||
            (userAccountsList.length > 0 && userAccountsList[0])
        )
      );
    } catch (error) {
      console.error("Error fetching user accounts:", error);
    }
  };

  // useEffect to fetch user accounts when activeUser changes
  useEffect(() => {
    if (activeUser) {
      FetchUserAccounts();
    }
  }, [activeUser]);

  useEffect(() => {
    activeAccountUser !== null &&
      activeAccountRedux &&
      dispatch(
        getAccountMetrics({ idToken: idToken, loginId: activeAccountRedux })
      );
  }, [activeAccountUser]);
  console.log(activeAccountRedux, "activeAccountRedux");

  useEffect(() => {
    setActiveAccountUser(activeAccountRedux);
  }, [activeAccountRedux]);

  return (
    <>
      <Tabination variant={3} tabItems={items} activeTab={0} />
      <div className="traderslist-2">
        <Routes>
          <Route
            path="/"
            element={<Navigate to="account-overview" replace={true} />}
          />
          <Route
            path="account-overview"
            element={<AccountOverview accountsData={accountsData} />}
          />
          <Route
            path="trade-history"
            element={
              <TradeHistory
                tableData={accountsData?.account_metrics?.deals}
                isTradelocker={accountsData.trading_platform}
              />
            }
          />
          <Route path="transaction-history" element={<TransactionHistory />} />
          <Route
            path="affiliate-list"
            element={<AffiliateTable activeUser={activeUser} />}
          />
          <Route
            path="account-details"
            element={<ProfileDetails activeUser={activeUser} />}
          />
        </Routes>
      </div>
    </>
  );
}

export default TradersList2;
